import { render, staticRenderFns } from "./FeatureEvent.vue?vue&type=template&id=9ee2e836&scoped=true&"
import script from "./FeatureEvent.vue?vue&type=script&lang=js&"
export * from "./FeatureEvent.vue?vue&type=script&lang=js&"
import style0 from "./FeatureEvent.vue?vue&type=style&index=0&id=9ee2e836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee2e836",
  null
  
)

export default component.exports